// @ts-nocheck

import React, { useState } from "react";
import { Modal, Steps, Button, message } from "antd";
import Credentials from "./credentials"; // Destination form
import SourceForm from "./source"; // Source form
import axios from "axios";
import { CREATE_CONNECTION } from "../../util"; // Your API URL

const { Step } = Steps;

const PopupModal = ({
  isVisible,
  onClose,
  editConnection,
  setEditConnection,
}) => {
  const [currentStep, setCurrentStep] = useState(0); // Step state
  const [destinationData, setDestinationData] = useState({}); // Data from destination form
  const [sourceData, setSourceData] = useState({}); // Data from source form
  const [loading, setLoading] = useState(false);
  const [resetForms, setResetForms] = useState(false);

  // Handle the next button
  const handleNext = () => {
    setCurrentStep(currentStep + 1);
  };

  // Handle the previous button
  const handlePrevious = () => {
    setSourceData(sourceData);
    setCurrentStep(currentStep - 1);
  };

  // Handle close
  const handleClose = () => {
    onClose();
    setDestinationData({});
    setSourceData({}); // Reset source data as well
    setEditConnection(null);
    setResetForms(true);
    setCurrentStep(0);
  };

  // Combine data from both forms and send to the API
  const handleFinish = async (values) => {
    setLoading(true);
    const payload = {
      connectionName: sourceData?.connectionName, // Assuming connection name is in the destination form
      sourceData: {
        ...sourceData, // Collected from source form
      },
      destinationData: {
        ...values, // Collected from destination form
      },
    };

    try {
      if (editConnection && Object.keys(editConnection).length > 0) {
        // Update connection if editConnection exists
        await axios.put(
          `${CREATE_CONNECTION}/${editConnection.connectionName}`,
          payload
        );
        message.success("Connection updated successfully!");
      } else {
        // Create new connection
        await axios.post(CREATE_CONNECTION, payload);
        message.success("Connection created successfully!");
      }
      handleClose();
    } catch (error) {
      message.error(
        editConnection
          ? "Failed to update connection!"
          : "Failed to create connection!"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="FTP Connection"
      open={isVisible}
      onCancel={handleClose}
      width={1000}
      footer={null}
    >
      <Steps current={currentStep} style={{ marginBottom: 20 }}>
        <Step title="Source Information" />
        <Step title="Destination Information" />
      </Steps>

      {/* Render the form based on the current step */}
      {currentStep === 0 && (
        <SourceForm
          editConnection={editConnection}
          sourceData={sourceData}
          setSourceData={setSourceData} // Pass function to set source data
          handleNext={handleNext} // Call handleNext to go to the next step
          setResetForms={setResetForms}
          resetForms={resetForms}
        />
      )}

      {currentStep === 1 && (
        <Credentials
          editConnection={editConnection}
          destinationData={destinationData}
          setDestinationData={setDestinationData} // Pass function to set destination data
          handlePrevious={handlePrevious}
          handleFinish={handleFinish}
          setResetForms={setResetForms}
          resetForms={resetForms}
        />
      )}
    </Modal>
  );
};

export default PopupModal;
